let imagesLoaded = false;

$(window).on('load', function() {   
    setTimeout(function() {
        imagesLoaded = true;
        removeTrava();
        animaSite();
        $(window).scroll();
    });
});

$(document).ready(function () {
    // npm run watch:js
    // alert("carregou");
    
    $("body").addClass("travaScroll");
    $("body").addClass("carregando");

    /**********************
    Menu hamburguer
    ***********************/
    // $(".btnMenuHamburguer").on("click", function (evt) {
    //     evt.preventDefault();
    //     $("body").toggleClass("menuON");
    //     $(".wrapper").toggleClass("ON");
    //     $(this).toggleClass("ON");
    //     $('.menuMobile').toggleClass('ON');
    // });
    // $('.btFecharMenuMobile').on("click", function (evt) {
    //     evt.preventDefault();
    //     $('.btnMenuHamburguer').trigger("click");
    //     $('.menuMobile').removeClass('ON');
    //     setTimeout(function() {
    //         $("body").removeClass("menuON");
    //     }, 300);
    // });

    // $(".menuMobile .logo").html($(".menuFixo .logoPromocao").html());
    // $(".menuMobile .menu").html($(".menuFixo .menu ").html());
    // $(".menuMobile .menu ul").append($("footer .menu-modal-footer").html());
    // // $('.menuMobile .menu').append($('footer .menu-midias').html());

    // $(".modaiSalut").modaiSalut();
    
    /****************************
    Menu anchor
    *****************************/
    // alturaMenu = $(".menuFixo").height();

    // $(document).on("scroll", onScroll);
    // $('.menuFixo .menu a.preventHome[href^="#"], .menuMobile .menu a.preventHome[href^="#"]').on("click", function (e) {
    //     if ($(".paginaHome").length > 0) {
    //     e.preventDefault();
    //     $(document).off("scroll");
    //     var delayAnimacao = 0;
    //     if ($("body").hasClass("menuON")) {
    //         $(".btnMenuHamburguer").trigger("click");
    //         delayAnimacao = 600;
    //     }

    //     $("a").each(function () {
    //         $(this).removeClass("ativo");
    //     });
    //     $(this).addClass("ativo");

    //     var target = this.hash, menu = target;
    //     $target = $(target);

    //     setTimeout(function () {
    //         $("html, body")
    //         .stop()
    //         .animate({ scrollTop: $target.offset().top + 2 - alturaMenu, }, 500, "swing",
    //             function () {
    //                 $(document).on("scroll", onScroll);
    //             }
    //         );
    //         }, delayAnimacao);
    //     }
    // });

    // sanfona();
    // eyePassword();
    svg();
    // carrossel();
    // $(window).resize(function () {
    //     temScroll();
    //     // carrossel();
    // });

    $("body").on("click", "[data-vaipradiv]", function (e) {
        e.preventDefault();
        var ancora = $(this).data("vaipradiv");
        $("html, body").animate( { scrollTop: $(ancora).offset().top }, 500 );
    });

    /************************
    Ajuste altura footer
    *************************/
    // $(window).resize(function () {
    //     footerAlign();
    // });
    // footerAlign();
    // setTimeout(function () {
    //     footerAlign();
    //     // carrossel();
    // }, 300);

    /************************
    Modo Gus
    *************************/
    let searchParams = new URLSearchParams(window.location.search);
    var qualModo = searchParams.get("mode");
    if (searchParams.has("mode")) {
       if (qualModo === "gus") {
           $("body").addClass("semAnimacao");
        }
    }
    
    /************************
    Efeito Paralax
    *************************/
    $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop();
        $('.ep-E').css('transform', 'translateX(' + (-scrollTop * 0.02) + 'px)');
        $('.ep-E2').css('transform', 'translateX(' + (-scrollTop * 0.05) + 'px)');
        $('.ep-E3').css('transform', 'translateX(' + (-scrollTop * 0.1) + 'px)');
        $('.ep-E4').css('transform', 'translateX(' + (-scrollTop * 0.4) + 'px)');

        $('.ep-D').css('transform', 'translateX(' + (scrollTop * 0.02) + 'px)');
        $('.ep-D2').css('transform', 'translateX(' + (scrollTop * 0.05) + 'px)');
        $('.ep-D3').css('transform', 'translateX(' + (scrollTop * 0.1) + 'px)');
        $('.ep-D4').css('transform', 'translateX(' + (scrollTop * 0.4) + 'px)');

        $('.ep-C').css('transform', 'translateY(' + (-scrollTop * 0.02) + 'px)');
        $('.ep-C2').css('transform', 'translateY(' + (-scrollTop * 0.05) + 'px)');
        var scaleFactor = 1 + (scrollTop * 0.0008);
        $('.ep-C3').css('transform', 'scale(' + scaleFactor + ') translateY(' + (-scrollTop * 0.1) + 'px)');
        $('.ep-C4').css('transform', 'translateY(' + (-scrollTop * 0.4) + 'px)');

        $('.ep-B').css('transform', 'translateY(' + (scrollTop * 0.02) + 'px)');
        $('.ep-B2').css('transform', 'translateY(' + (scrollTop * 0.05) + 'px)');
        var scaleFactor2 = 1 + (scrollTop * 0.0003);
        $('.ep-B3').css('transform', 'scale(' + scaleFactor2 + ') translateY(' + (scrollTop * 0.25) + 'px)');
        $('.ep-B4').css('transform', 'translateY(' + (scrollTop * 0.4) + 'px)');
    });

});


/***********************************************************************************************************

                                                    FUNÇÕES                                                 

***********************************************************************************************************/

/****************************
Travamento para Carregando
*****************************/
function removeTrava() {
    $(".contLoader").addClass("off");
    $("body").removeClass("travaScroll");
}

function callBackModal() {
    // carrossel();
}

/************************
rolou scroll
*************************/
// $(window).scroll(function () { rodouScroll(); });
// $(window).resize(function () { rodouScroll(); });

// function rodouScroll() {
//     valorScroll = $(window).scrollTop();
//     if($('#home, #capa').height() < $(window).height()) {
//         if (valorScroll < ($('#home').height()/2)) {
//             $(".menuFixo").removeClass("scroll");
//             $(".btn-home").removeClass("inativo");
//             $(".btn-tela").addClass("inativo");
//         } else {
//             $(".menuFixo").addClass("scroll");
//             $(".btn-home").addClass("inativo");
//             $(".btn-tela").removeClass("inativo");
//         }
//     } else {
//         $(".btn-home").addClass("inativo");
//         $(".btn-tela").removeClass("inativo");
//     }
// }

/****************************
Anima site
*****************************/
function animaSite() {
    $("body").removeClass("carregando");

    var nomeSection = [];
    $("body").find(".anima").each(function () {
        nomeSection.push(this.id);
    });

    function isScrolledIntoView(elem) {
        var sectionTop = $(elem).offset().top;
        var telaTop = $(window).scrollTop();

        var docViewBottom = telaTop + $(window).height();
        var elemBottom = sectionTop + $(elem).height() / 1.5;

        // console.log(parseInt(elemBottom), parseInt(docViewBottom));

        if (elem != "#footer") {
            return telaTop >= sectionTop - $(window).height() / 1.25;
        } else {
            return parseInt(elemBottom) <= parseInt(docViewBottom);
        }
    }

    $(window).scroll(function () {
        for (var i = 0; i < nomeSection.length; i++) {
            const $sec = $("#" + nomeSection[i]);

            if (isScrolledIntoView("#" + nomeSection[i]) || $(".wrapper").height() <= $(window).height()) {
                if (!$sec.hasClass("monta")) {
                    $sec.addClass("monta");
                    aplicaDelaysAnimacao(); // só aplica uma vez por section
                }
            }
        }
    });
}


/**********************
Aplica delay
***********************/
function aplicaDelaysAnimacao() {
    const animClasses = [
        'slide-up', 'slide-down', 'slide-left', 'slide-right',
        'zoom-in', 'zoom-in-pa', 'zoom-out',
        'gira-direita', 'gira-esquerda', 'shake',
        'espelho', 'fade', 'flutua', 'gira', 'pulsar', 'girando'
    ];

    const delayInterval = 150; // você pode ajustar aqui
    const animDuration = 1000; // tempo médio de duração da animação

    $('.monta').each(function () {
        let delay = 0;

        const $animados = $(this).find('*').filter(function () {
            const classes = $(this).attr('class');
            if (!classes) return false;
            return animClasses.some(anim => classes.split(' ').includes(anim));
        });

        $animados.each(function () {
            const $el = $(this);

            // Aplica o delay diretamente via style inline
            $el.css({
                'animation-delay': delay + 'ms'
            });

            // Força reflow (garante que o navegador aplique a mudança)
            void $el[0].offsetWidth;

            // Adiciona a classe "animado" após a animação
            setTimeout(function () {
                $el.addClass('animado');
            }, delay + animDuration);

            delay += delayInterval;
        });
    });
}


/************************
Muda cor do svg
*************************/
function svg() {
    $("img.svg").each(function () {
        var $img = $(this);
        var imgID = $img.attr("id");
        var imgClass = $img.attr("class");
        var imgURL =
        $img.attr("src") + "?c=" + (Math.random() + 1).toString(36).substring(7);

        $.get( imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find("svg");

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== "undefined") {
                $svg = $svg.attr("id", imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== "undefined") {
                $svg = $svg.attr("class", imgClass + " replaced-svg");
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr("xmlns:a");

            // Replace image with new SVG
            $img.replaceWith($svg);
        }, "xml" );
    });
}

// /************************
// Carrossel
// *************************/
// function destroyCarousel(carrossel) {
//     if (carrossel.hasClass("slick-initialized")) {
//         carrossel.slick("destroy");
//     }
// }
// function modalEstaAberta() {
//     return $(".modalSalut.ON").length > 0;
// }
// function carrossel() {
//     /************************
//     Carrossel
//     *************************/
//     // if ($(".carrossel-depoimento").length > 0) {
//     //     console.log("carrossel-depoimento");
//     //     $(".carrossel-depoimento").slick({
//     //         vertical: true,
//     //         verticalSwiping: true,
//     //         slidesToShow: 3,
//     //         slidesToScroll: 1,
//     //         infinite: false,
//     //         dots: false,
//     //         arrows: true
//     //     });
//     // }
//     $(".carrossel-depoimento").slick({
//         speed: 800,
//         dots: false,
//         infinite: false,
//         slidesToShow: 1,
//         adaptiveHeight: true,
//         vertical: true,
//         verticalSwiping: true,
//     });
//     // if ($(window).width() > 767) {
//     // } else {
//     //     $(".carrossel-depoimento").slick({
//     //         speed: 800,
//     //         dots: false,
//     //         infinite: false,
//     //         slidesToShow: 1,
//     //         adaptiveHeight: true,
//     //         vertical: false,
//     //     });
//     // }

//     if ($(".carrossel").length > 0) {
//         destroyCarousel($(".carrossel"));
//         $(".carrossel").slick({
//         dots: false,
//         infinite: false,
//         centerMode: false,
//         slidesToShow: 3,
//         adaptiveHeight: true,

//         responsive: [
//             {
//                 breakpoint: 1160,
//                 settings: {
//                     slidesToShow: 3,
//                 },
//             },
//             {
//                 breakpoint: 792,
//                 settings: {
//                     slidesToShow: 2,
//                 },
//             },
//             {
//                 breakpoint: 580,
//                 settings: {
//                     slidesToShow: 1,
//                 },
//             },
//         ],
//         });
//     }

//     if ($(".carrossel-modal").length > 0) {
//         var images = $(".carrossel-modal img");
//         var totalImages = images.length;
//         var imagesLoaded = 0;

//         images.each(function () {
//             var img = new Image();
//             img.onload = function () {
//                 imagesLoaded++;
//                 if (imagesLoaded === totalImages) {
//                     destroyCarousel($(".carrossel-modal"));
//                     $(".carrossel-modal").slick({
//                         lazyLoad: 'ondemand',
//                         dots: false,
//                         infinite: false,
//                         centerMode: false,
//                         slidesToShow: 4,
//                         adaptiveHeight: true,

//                         responsive: [
//                             {
//                                 breakpoint: 1160,
//                                 settings: {
//                                     slidesToShow: 3,
//                                 },
//                             },
//                             {
//                                 breakpoint: 792,
//                                 settings: {
//                                     slidesToShow: 2,
//                                 },
//                             },
//                             {
//                                 breakpoint: 580,
//                                 settings: {
//                                     slidesToShow: 1,
//                                 },
//                             },
//                         ],
//                     });
//                 }
//             };
//             img.src = $(this).attr("src");
//         });
//     }
// }

// /**********************
// Sanfona
// ***********************/
// function sanfona() {
//     $(".at-title").on("click", function (evt) {
//         $(this)
//         .toggleClass("active")
//         .next(".at-cont")
//         .slideToggle()
//         .parent()
//         .siblings()
//         .find(".at-cont")
//         .slideUp()
//         .prev()
//         .removeClass("active");
//     });
// }

/****************************
Controla trava Loader principal
*****************************/
// function footerAlign() {
//     // console.log("footer");
//     $("footer").css("height", "auto");
//     var footerHeight = $("footer").outerHeight();
//     $(".wrapper").css("padding-bottom", footerHeight);
//     $("footer").css("height", footerHeight);
// }

/****************************
Função Menu anchor
*****************************/
// function onScroll(event) {
//     var scrollPos = $(document).scrollTop() + alturaMenu;
//     $(".menuFixo .menu li a.preventHome").each(function () {
//         var currLink = $(this);
//         var refElement = $(currLink.attr("href"));
//         if(refElement.length > 0 &&  refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
//             $(".menuFixo .menu ul li a").removeClass("ativo");
//             currLink.addClass("ativo");
//         } else {
//             currLink.removeClass("ativo");
//         }
//     });
// }

// function eyePassword() {
//     $('.box-editar input').each(function (e) {
// 		if ($(this).next('i').length == 0) {
// 			$('<i class="bi bi-pencil"></i>').insertAfter($(this));
// 		}
// 	});
//     $('input[type="password"]').each(function (e) {
//         if ($(this).next("i").length == 0) {
//             $('<i class="bi bi-eye-slash togglePassword"></i>').insertAfter($(this));
//         }
//     });
//     $(".togglePassword").off("click");
//     $(".togglePassword").each(function (e) {
//         $(this).on("click", function () {
//             var inputSenha = $(this).prevAll("input");
//             const type = inputSenha.attr("type") === "password" ? "text" : "password";
//             inputSenha.attr("type", type);
//             $(this).toggleClass("bi-eye");
//         });
//     });
// }

// /********************
// Menu aba regulamento
// *********************/
// function abaRegulamento() {
//     if ($(".modalSalut .menu-aba").length > 0) {
//         if ($(".modalSalut").hasClass("regulamento") || $(".modal").hasClass("duvidas")) {
//             $(".modal-conteudo").addClass("abaRegulamento");
//             $(".modal-conteudo.abaRegulamento .headerModal").append("<div class='menu-aba'>" + DOMPurify.sanitize($(".abaRegulamento .menu-aba").html()) +"</div>");
//             btAba();
//             temScroll();
//         } else {
//             $(".modal-conteudo").removeClass("abaRegulamento");
//         }
//     }
// }

// function btAba() {
//     $(".modal-conteudo .menu-aba .m .bt-aba").bind("click", function (evt) {
//         evt.preventDefault();
//         var qual = $(this).index() + 1;

//         $(".modal-conteudo .menu-aba .m .bt-aba").removeClass("on");
//         $(".modal-conteudo .aba-cont").addClass("off");

//         $(this).addClass("on");
//         $(".modal-conteudo .aba-cont.cont" + qual).removeClass("off");

//         $(".modal-conteudo.abaRegulamento .tela").animate({ scrollTop: 0 }, "500");
//         temScroll();
//     });
// }

// function temScroll() {
//     $(".modalSalut .conteudo").each(function () {
//         if ($(this)[0].scrollHeight - 10 > $(this).height()) {
//             $(this).addClass("temScroll");
//         } else {
//             $(this).removeClass("temScroll");
//         }
//     });
// }

function mostraLoader(abre) {
    if (abre) {
        $(".boxLoader").addClass("ON");
    } else {
        $(".boxLoader").removeClass("ON");
    }
}